import { Injectable } from '@angular/core';
import { DatasourceGitService } from '@y42/datasource';
import { ErrorHandlerService } from '@y42/error-handling';
import { Y42GitFolders } from '@y42/feature/git';
import { GitQuery, GitService } from '@y42/git';
import { IntegrationSettingsGitModel } from './integration.model';

@Injectable({ providedIn: 'root' })
export class IntegrationGitService extends DatasourceGitService {
  constructor(
    protected readonly git: GitService,
    protected readonly gitQuery: GitQuery,
    protected readonly errorHandlerService: ErrorHandlerService,
  ) {
    super({
      name: 'Integration',
      type: Y42GitFolders.Integration,
      git,
      gitQuery,
      errorHandlerService,
      settingsGitModel: IntegrationSettingsGitModel,
      hydrationDefinition: {
        1: {
          modelType: 'folder',
          childType: 'folder',

          models: {
            '.y42': {
              'secret.enc': {
                storeModelPropertyName: 'secret',
              },
            },
          },
        },
        2: {
          modelType: 'folder',
          models: {
            tests: {
              fileName: 'tests.json',
            },
          },
        },
      },
    });
  }
}
